import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { PressSection } from '../../components/PressSection';
export function PressPage() {
  return <div className="bg-white" data-id="element-859">
      <PageHero title="Press & Media" subtitle="The latest news, announcements, and recognition for JJ Group." data-id="element-860" />

      {/* We reuse the existing PressSection component here, but without its own background color to blend in */}
      <div className="py-12" data-id="element-861">
        <PressSection data-id="element-862" />
      </div>

      <section className="py-24 bg-brand-dark text-white text-center relative overflow-hidden" data-id="element-863">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-864"></div>
        <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-865">
          <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-866">
            Media Inquiries
          </h2>
          <p className="text-white/70 font-light mb-10" data-id="element-867">
            For press inquiries, interview requests, or high-resolution image
            assets, please contact our media relations team.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-868">
            <a href="mailto:press@jibekjolugroup.com" className="bg-brand-gold text-brand-dark px-8 py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-white transition-colors" data-id="element-869">
              Email Press Team
            </a>
            <a href="mailto:press@jibekjolugroup.com?subject=Press%20Kit%20Request" className="border border-brand-gold text-brand-gold px-8 py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-brand-gold hover:text-brand-dark transition-colors inline-block" data-id="element-870">
              Download Press Kit
            </a>
          </div>
        </div>
      </section>
    </div>;
}